@if (content) {
<div class="flex-column"
     [class]="content.backgroundColor || 'bg-col-52'">
    <div class="wrap-l wrap-x w-12-s w-12-m flex-column-reverse-m flex-column-reverse-s flex flex-middle">
        <div class="m-b-8 m-b-4-s m-b-4-m w-12-s w-12-m "
             [class]="(categoryImage || content.sideImage) && client.sizeId > 1 ? 'w-7 p-r-10' : 'w-8'">
            <div class="wrap-s wrap-m">
                <breadcrumbs class="m-b p-t-4-s p-t-4-m p-t-8 block no-scrollbar overflow-auto" />
                <h1 class="h2 m-b col-1">{{ categoryName }}</h1>
                @if (categoryDescription) {
                <p class="p1 col-1 text cms-html"
                   [innerHTML]="categoryDescription"></p>
                }
            </div>
            @if(content.filters && content.filters.length) {
            <div *ifSize="'SM'"
                 class="w-12 m-l left _drag-container"
                 dragScroll>
                <ng-container *ngTemplateOutlet="links" />
            </div>
            <div *ifSize="'XL'">
                <ng-container *ngTemplateOutlet="links" />
            </div>
            }
        </div>
        @if((content.sideImage || categoryImage) && (content.showSideImage ?? true)){
        <div class="w-12-s w-12-m w-5-l w-5-x overflow-hidden">
            <df-image-wrapper>
                <img class="w-12"
                     [dfImage]="content.sideImage || categoryImage"
                     [alt]="categoryName || ''"
                     [ratio]="'5/2'">
            </df-image-wrapper>
        </div>
        }
    </div>
</div>
}

<ng-template #links>
    @for (item of content?.filters; track item) {
    <a class="inline-flex flex-middle va-t link m-t _drag-item"
       [class.m-r]="!$last"
       [attr.href]="item.url">
        <span class="s1"
              *iCms="'label' of item"></span>
    </a>
    }
</ng-template>
